<!-- HEADER -->
<header>

  <!-- MENU BLOCK -->
  <div class="menu_block">

    <!-- CONTAINER -->
    <div class="container clearfix">

      <!-- SEARCH FORM
      <div id="search-form" class="pull-right">
        <form method="get" action="#">
          <input type="text" name="Search" value="Search" onFocus="if (this.value == 'Search') this.value = '';" onBlur="if (this.value == '') this.value = 'Search';" />
        </form>
      </div><!-- SEARCH FORM -->

      <!-- MENU -->
      <div>
        <nav class="navbar navbar-expand-lg navbar-light">
          <span class="logo"><a class="navbar-brand" href="index.html" ><span class="b1">Tempo</span><span class="b2">na</span><span class="b3">Vida</span></a></span>
          <button class="navbar-toggler" (click)="isCollapsed = !isCollapsed" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>

          <div class="collapse navbar-collapse" id="navbarSupportedContent" [ngbCollapse]="isCollapsed">
            <ul class="navbar-nav mr-auto">
              <li class="nav-item active">
                <a class="nav-link" routerLink="/">Home <span class="sr-only">(current)</span></a>
              </li>
              <li class="nav-item">
                <a class="nav-link" routerLink="/animacoes">Animações</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" routerLink="/materiais">Materiais</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" routerLink="/cronobiologia">Cronobiologia?</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" routerLink="/contatos">Contatos</a>
              </li>

            </ul>
          </div>
        </nav>
      </div><!-- //MENU -->
    </div><!-- //MENU BLOCK -->
  </div><!-- //CONTAINER -->
</header><!-- //HEADER -->
